<!--详情页-->
<template>
  <div class="course-detail-page">
    <div class="courseDetail">
      <!-- 顶部封面 -->
      <div>
        <VideoGraph v-if="flagHeader" />
        <mainGraph
          v-else
          :courseId="courseId"
          :containCurriculumId="containCurriculumId"
          ref="mainGraph"
          @openLiveListBox="openLiveListBox"
        />
      </div>
      <!-- 活动价格 -->
      <AcvitityPrice v-show="!buyStatus.length" />
      <!--  课程本名称、课时等  -->
      <div class="basicInformation">
        <CourseNameModule />
      </div>
      <!--  课程价格  -->
      <div class="coursePriceModule">
        <CoursePrice v-show="allAcvitity.activeType === 0"></CoursePrice>
        <CourseDiscount
          :by_stages_price="by_stages_price"
          :huabeiStageInfo="huabeiStageInfo"
          :wholeGiftlist="wholeGiftlist"
          :giftMaterialList="giftMaterialList"
        />
      </div>
      <!--  课程选择  -->
      <CourseSelect :courseSelectList="courseSelectList"></CourseSelect>
      <!--  课程tab -->
      <div class="tab-out-empty"></div>
      <div ref="tabOutside"></div>
      <SpringFestival />
      <div class="courseTabsModule">
        <courseDetailTabs :tabFixed="tabFixed"></courseDetailTabs>
        <!-- <Foot/> -->
      </div>
      <!-- 底部 -->
      <!-- v-if="getDetailSuccess" -->
      <AcvitityFoot
        :type="allAcvitity.activeType === 5 ? 'groupBuy' : 'course'"
        :buyBtnData="PageBuyBtnData"
        :by_stages_price="by_stages_price"
        @openAppDialog="openAppDialog"
        ref="foot"
        :buyBtnLoading="buyBtnLoading"
        :cartCount="cartCount"
      />
      <van-popup v-model="liveListBoxShow" :closeable="true">
        <!-- 直播中列表盒子 -->
        <div class="courseDetailLiveListBox">
          <img
            class="liveListBoxIcon"
            src="../../assets/img/productDetail/livingListIcon.png"
            alt
          />
          <liveListBox
            :liveList="
              containCurriculumData.livingInfoRespVOS ? containCurriculumData.livingInfoRespVOS : []
            "
          ></liveListBox>
        </div>
      </van-popup>
      <!-- loading -->
      <Loading ref="load" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import wx from 'weixin-js-sdk';
import SpringFestival from '@/components/springFestival/index.vue';
import { reqPostGroupCheck } from '@/api/courseDetail/groupBuy/groupBuy';
import { getTaskApi } from '@/api/learningGuidePage/index';
import { reqPrice } from '@/api/pay';
import { reqAddCart } from '@/api/courseDetail/shoppingCar/shoppingCar';
import courseDetailTabs from './courseTabs.vue';
import CourseNameModule from '../../components/branchSchoolCourseDetail/courseNameModule/CourseNameModule.vue';
import CoursePrice from '../../components/branchSchoolCourseDetail/CoursePrice.vue';
import CourseSelect from '../../components/branchSchoolCourseDetail/CourseSelect.vue';
import {
  reqCourseDetail,
  reqCatalogs,
  reqSubOrder,
  reqClassNameType,
} from '../../api/courseDetail/index';
import AcvitityPrice from './courseActivity/acvitityPrice.vue';
import AcvitityFoot from './courseActivity/acvitityFoot.vue';
import mainGraph from '../../components/branchSchoolCourseDetail/courseMainGraphModule/mainGraph.vue';
import VideoGraph from '../../components/branchSchoolCourseDetail/courseMainGraphModule/videoGraph.vue';
import CourseDiscount from './courseComponents/courseDiscount.vue';
import liveListBox from '../../components/branchSchoolCourseDetail/liveListBox/LiveListBox.vue';
import {
  setTokenFromCookie,
  gioPlatform,
  replaceHyphens,
  beforePageName,
  ConUnlocking_GIO,
  statusTextMap,
} from '../../utils/tools';
import Loading from '../../components/loading/loading.vue';

export default {
  components: {
    courseDetailTabs,
    CourseNameModule,
    CoursePrice,
    CourseSelect,
    AcvitityPrice,
    mainGraph,
    VideoGraph,
    AcvitityFoot,
    CourseDiscount,
    liveListBox, // 直播中列表盒子
    Loading,
    // Foot,
    SpringFestival,
  },
  data() {
    return {
      courseId: this.$route.query.courseId, // 课程id
      courseSelectList: [],
      buyStatus: [], // 是否购买，同时储存了开课后的信息
      actionType: 0, // 1免费领取后打开直播间 2未登录前点击购买,登录后需要触发购买
      loading: {}, // 免费领取loading
      courseDetail: {}, // 课程详情
      containCurriculumId: 0, // 课表id
      videoList: [], // 试听列表
      salePrice: '', // 售价
      by_stages_price: 0, // 分期价格
      detailSuccessPopupShow: false, // 领取成功popup
      scrollTopIt: 0, // scrollTop
      liveListBoxShow: false, // 直播列表
      huabeiStageInfo: {}, // 花呗分期的信息
      mutationObserverVal: null,
      windowHistoryLength: 0,
      getDetailSuccess: false,
      activityType: 'groupBuy',
      buyBtnLoading: false,
      gioVisitUserId:'',
      cartCount: 0, // 购物车数量
      wholeGiftlist: null, // 赠送优惠券list
      giftMaterialList: null, // 赠送实物list
      flagHeader: false,
      currentTime: new Date().getTime(), // 当前时间
      PageBuyBtnData: {}, // 购买按钮状态
    };
  },

  computed: {
    ...mapState([
      'courseBaseData',
      'userInfo',
      'productSku',
      'allAcvitity',
      'containCurriculumData',
    ]),
    tabFixed() {
      let itFixed = false;
      itFixed = this.scrollTopIt > this.$refs.tabOutside?.offsetTop;
      return itFixed;
    },
    buyBtnData: {
      get() {
        let data = null;
        if (JSON.stringify(this.courseBaseData) === '{}') {
          return {
            bgColor: 'notBuy',
            btnTxt: '加载中',
            state: -101000,
            status: -101000,
          };
        }
        const { activeType, nowAcvitity } = this.allAcvitity;
        const {
          status,
          isValid,
          validPeriodType,
          isSetStock,
          availableStock,
          isRepeatBuy,
          isChoiceSpec,
          sellPrice,
          productId,
        } = this.courseBaseData;
        const { productSkuId, price } = this.productSku;
        if (status <= 3) {
          data = {
            bgColor: 'notBuy',
            btnTxt: '未上架',
            state: 1,
            status: 0,
          };
        } else if (!isValid && validPeriodType !== 1 && productId) {
          data = { bgColor: 'notBuy', btnTxt: '已过期', state: 3 };
        } else if (this.buyStatus.length && !isRepeatBuy) {
          data = {
            bgColor: 'study',
            btnTxt: '去学习',
            state: 5,
            status: 0,
          };
        } else if (isSetStock === 1 && availableStock <= 0) {
          data = { bgColor: 'sellOut', btnTxt: '已售罄', state: 4 };
        } else if (status === 6) {
          data = { bgColor: 'notBuy', btnTxt: '已下架', state: 2 };
        } else if (
          (isChoiceSpec === 0 && !sellPrice) ||
          (isChoiceSpec === 1 && productSkuId && !price) ||
          (isChoiceSpec === 1 && !productSkuId && !sellPrice)
        ) {
          data = {
            bgColor: 'canBuy',
            btnTxt: '免费领取',
            state: 6,
            status: 1,
          };
        } else if (
          (activeType === 2 && nowAcvitity.state === 1) ||
          (activeType === 3 && nowAcvitity.state === 1 && nowAcvitity.stockNum > 0)
        ) {
          data = {
            bgColor: 'canBuy',
            // btnTxt: '立即秒杀',
            btnTxt: '马上付款',
            state: 8,
            status: 2,
          };
        } else if (activeType === 1 && nowAcvitity.state === 1) {
          data = {
            bgColor: 'canBuy',
            btnTxt: '立即抢购',
            state: 9,
            status: 2,
          };
        } else if (activeType === 4) {
          data = {
            bgColor: 'coupon',
            btnTxt: '领券购买',
            state: 10,
            status: 2,
          };
        } else {
          data = {
            bgColor: 'canBuy',
            btnTxt: '立即购买',
            state: 7,
            status: 2,
          };
        }
        if (this.$root.miniprogram && !this.$root.miniprogramBuyCourse && data.state > 6) {
          data = {
            bgColor: 'canBuy',
            btnTxt: '了解更多',
            state: 11,
            status: 2,
          };
        }
        return data;
      },
      set(value) {
        this.PageBuyBtnData = value;
      },
    },
  },

  watch: {
    buyBtnData(value) {
      this.PageBuyBtnData = value;
      this.wxInit(value)
    },
    userInfo(data) {
      if (data.id) {
        this.getRepeatBuy();
      } else {
        // 退出登录清空购买状态
        this.buyStatus = [];
        this.$store.dispatch('saveBuyStatus', []);
      }
    },
    courseDetail(newVal, oldVal) {
      if (newVal.name !== oldVal.name) {
        document.title = newVal.name || '课程详情';
      }
      if (newVal.productId && this.userInfo.id) {
        this.getRepeatBuy();
      }
      // 默认取产品的价格
      this.salePrice = newVal.sellPrice;
    },
    productSku(skuInfo) {
      this.containCurriculumId = '';
      this.containCurriculumId = skuInfo.containCurriculumId;
      this.getCatalog();
      // 计算分期价格
      // this.getPayAmount();
    },
    $route: {
      handler() {
        this.$router.go();
      },
      deep: true,
    },
    allAcvitity: {
      handler() {
        this.getDetailSuccess = true;
        this.getPayAmount();
      },
      deep: true,
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.detailInit();
      const param = sessionStorage.getItem('fromPageUrl')
        ? JSON.parse(sessionStorage.getItem('fromPageUrl'))
        : {};
      if (from.path === '/' && !sessionStorage.getItem('webLoadMode') === 'refresh') {
        // 判断专题页跳转
        param.fromPageUrl = '';
        param.fromPageUrlLast = document.referrer;
      } else if (!(from.path === '/' && sessionStorage.getItem('webLoadMode') === 'refresh')) {
        // 非刷新状态
        param.fromPageUrlLast = `${window.location.origin}${from.fullPath}`;
      }
      sessionStorage.setItem('fromPageUrl', JSON.stringify(param));
    });
  },

  mounted() {
    window['iqhApp2jsBridge.triggerSC'] = {};
    // 分享按钮
    window['iqhApp2jsBridge.triggerSC'].shareCourseJS = this.shareCourseJS;
    // console.log(window['iqhApp2jsBridge.triggerSC']);
    // 滚动条监听 tab栏吸顶
    this.scrollInit();

    // 进入详情页隐藏首页底部的tab
    this.$sendToApp('hiddenShareButton', { showShare: 1 }, false);

    if (this.$root.$data.isApp) {
      this.$sendToApp('getGIoVisitUserId', false);
    }
    window.setGIoVisitUserId = (value) => {
      this.getAndroid(value);
    };
    this.getUUid();

    // eslint-disable-next-line no-unused-expressions
    // 监听sku展示和隐藏的状态，用于更新购买按钮的状态，因为存在接口字段显示可以购买，但是有库存的sku被隐藏的情况；
    PubSub.subscribe('editBuybtnStatus', (data, curIndex) => {
      this.PageBuyBtnData = curIndex;
    });
  },
  methods: {
    getAndroid(value) {
      if (this.$root.$data.isApp) {
        this.gioVisitUserId = `{u:'${value || ''}', roomId: '${this.$route.query.liveRoomId || ''}',wechatSource:'${this.miniParams()}'}`;
      }
    },
    getUUid() {
      if (!this.$root.$data.isApp) {
        // eslint-disable-next-line
        let uuid = gio('getVisitUserId') || [];
        this.gioVisitUserId = `{u:'${uuid[0] || ''}', roomId: '${this.$route.query.liveRoomId || ''}',wechatSource:'${this.miniParams()}'}`;
      }
    },

    scrollInit() {
      const pageDiv = document.getElementsByClassName('course-detail-page')[0];
      const fun = () => {
        this.scrollTopIt = pageDiv.scrollTop; // 要做兼容 在模
      };
      pageDiv.addEventListener('scroll', fun, false);
    },
    detailInit() {
      // 添加变量为底部购买按钮栏是否显示，在获取到订单详情，在登录状态下需获取到按钮过麦状态后展示底部栏
      this.getDetailSuccess = false;
      this.getCourseDetail().then(() => {
        // 则先跳转登录后返回自动购买，添加checkGoOrderNow参数做判断
        // productSkuId避免sku重复监听时，重复提交接口
        // const checkGoOrderNow = window.sessionStorage.getItem('checkGoOrderNow');
        // if (checkGoOrderNow) {
        //   this.checkBuy();
        // }
      });
    },
    // header 分享按钮（原生交互）
    shareCourseJS() {
      const query = {
        url: window.location.href,
        title: this.courseDetail.name,
        content: '',
        icon: '',
      };
      this.$sendToApp('share', query, false);
    },

    // 分期计算 随sku变动
    async getPayAmount() {
      const { nowAcvitity, activeType } = this.allAcvitity;
      const { price, productSkuId } = this.productSku;
      const salePrice = activeType > 0 ? nowAcvitity.promotionPrice : price;
      if (salePrice < 100 || !productSkuId) {
        this.by_stages_price = -1;
      }
    },

    // 跳转到支付页面
    async jumpPayOrder1(val) {
      let query;
      const checkGoOrderNow = JSON.parse(window.sessionStorage.getItem('checkGoOrderNow'));
      if (checkGoOrderNow) {
        query = [
          {
            productId: checkGoOrderNow.productId,
            skuId: checkGoOrderNow.skuId,
            groupActivityId: checkGoOrderNow.groupActivityId || '',
            groupOrderType: checkGoOrderNow.groupOrderType || '',
          },
        ];
      } else if (val && val.source === 'group') {
        query = [
          {
            productId: this.courseId,
            skuId: this.productSku.productSkuId,
            groupActivityId: val.data.groupActivityId,
            groupOrderType: 'openGroup',
          },
        ];
      } else {
        query = [
          {
            productId: this.courseId,
            skuId: this.productSku.productSkuId,
          },
        ];
      }
      sessionStorage.removeItem('checkGoOrderNow');
      if (val && val.source === 'group') {
        const checkParam = {
          groupActivityId: val.data.groupActivityId,
          productId: this.courseId,
          productSkuId: this.productSku.productSkuId,
        };
        this.buyBtnLoading = true;
        const res = await reqPostGroupCheck(checkParam);
        this.buyBtnLoading = false;
        if (res.code !== 0) {
          this.$toast(res.msg || '活动验证失败');
          return;
        }
      }
      const { liveRoomId } = this.$route.query;
      if (!this.$root.$data.isApp) {
        this.$router.push({
          path: '/payOrder',
          query: { product: JSON.stringify(query), liveRoomId },
        });
        this.gioDefault(query);

        // return false;
      } else {
        // app内
        // eslint-disable-next-line no-lonely-if
        this.$sendToApp('buyCourseNew', { product: JSON.stringify(query), liveRoomId }, false);
        this.gioDefault(query);
      }
    },
    // 加入购物车
    async checkAddShopCar() {
      const query = {
        productId: this.courseId,
        skuId: this.productSku.productSkuId,
        type: 1, // 类型 1 产品 2 套餐
      };

      const res = await reqAddCart(query);
      if (res.code === 0) {
        this.$toast('已加入购物车');
        this.gioAddCart();
      } else {
        this.$toast(res.msg);
      }
    },
    handleHeaderCover(data) {
      this.flagHeader = !!(
        data.productCoverVideoRespVOS && data.productCoverVideoRespVOS.length > 0
      );
    },
    // 获取课程基本信息 ( /v1/product/ )
    async getCourseDetail() {
      return new Promise((resolve, reject) => {
        reqCourseDetail(this.courseId)
          .then((res) => {
            if (res.code === 0) {
              this.currentTime = res?.currentTime
                ? new Date(replaceHyphens(res?.currentTime)).getTime()
                : new Date().getTime();
              this.courseDetail = res.data;
              this.handleHeaderCover(res.data);
              this.$store.dispatch('saveCourseBaseData', res.data);
              this.checkCatalog();
              // 避免支付成功页修改title
              if (document && this.$route.name !== 'paySuccess') {
                document.title = res.data && res.data.name ? res.data.name : '课程详情';
              }
            }
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },

    // 校验课程是否可重复购买
    getRepeatBuy() {
    },

    // 购买前校验sku /赠品，....
    async checkBuy(index) {
      this.buyBtnLoading = true;
      this.buyBtnLoading = false;
      this.liveListBoxShow = false;
      // 判断是否已购买
      if (this.PageBuyBtnData.state === 5) {
        sessionStorage.removeItem('checkGoOrderNow');
        // 已购
        return;
      }
      if (index === 'disbaledBuy') return;
      if (this.PageBuyBtnData.state === 6) {
        // 免费
        this.freeCourseReceive(index);
      } else {
        // 付费
        // alert('AT  付费');
        this.jumpPayOrder1();
      }
    },

    // 接收（MainGraph/CoursePopup）组件打开直播间的动作
    receiveLiveRoom(index) {
      this.actionType = 1;
      const { isApp = false } = this.$root.$data;
      // if (!this.checkLogin()) return;
      // 校验是否登录
      if (!this.userInfo.id) {
        if (isApp) {
          this.$sendToApp('login', {}, true)
            .then(async () => {
              setTokenFromCookie();
              await this.$root.getUserInfo();
              this.checkBuy(index);
            })
            .catch((err) => console.log(err.toString()));
        } else {
          this.$router.push({
            path: '/registrationLogin',
            query: {
              redirect: this.$route.path,
              ...this.$route.query,
            }, // 将跳转的路由path作为参数，登录成功后跳转到该路由
          });
        }
      } else {
        this.checkBuy(index);
      }
    },
    // 子组件组件打开弹窗
    async openAppDialog() {
      const { id } = this.buyStatus[0];
      const res = await this.entranceTask(id);
      console.log('res', res);
      if (res === 'unFinished') {
        if (this.$root.miniprogram) {
          this.$toast('请前往app完成入学任务后，即可查看课程视频');
        } else {
          this.$router.push({
            path: '/entranceTask',
            query: {
              id,
            },
          });
        }
      } else if (res === 'finished') {
        if (this.$root.miniprogram) {
          wx.miniProgram.navigateTo({ url: `/myCourse/learningGuide/index?catalogId=${id}` });
        } else {
          this.$router.push({
            path: '/learningGuide',
            query: {
              catalogId: id,
            },
          });
        }
      }
    },
    async entranceTask(id) {
      const { code, data } = await getTaskApi(id);
      if (code === 0) {
        const { agreementId, agreementDone, examId, examDone, examinationFlag, examinationDone } =
          data;
        this.examId = examId;
        if (
          (agreementId && !agreementDone) ||
          (examId && !examDone) ||
          (examinationFlag && !examinationDone)
        ) {
          return 'unFinished';
        }
        return 'finished';
      }
      return 'err';
    },
    // 打开直播列表
    openLiveListBox() {
      this.liveListBoxShow = true;
    },
    // 课表相关
    // 校验有无课表
    checkCatalog() {
      const { productServiceRespVO } = this.courseDetail;
      // 无sku--查询产品的课表id
      const isDefault = this.courseDetail.productSkuRespVOList
        ? this.courseDetail.productSkuRespVOList.find((ele) => ele.isDefault === 1)
        : false;
      if (productServiceRespVO && productServiceRespVO.containCurriculumId && isDefault) {
        this.containCurriculumId = productServiceRespVO.containCurriculumId;
        this.getCatalog();
      }
      this.gioDetail();
    },
    // 查询课表
    async getCatalog() {
      if (!this.courseDetail.productId) return;
      if (this.containCurriculumId) {
        // 课表目录接口 （catalog/detail/）
        const res = await reqCatalogs(this.containCurriculumId);
        if (res.code === 0) {
          // 保存课表
          this.$store.dispatch('saveCourseCurriculum', res.data);
          this.videoList = res.data.videoInfoRespVOS;
        }
      } else {
        this.$store.dispatch('saveCourseCurriculum', {});
        this.videoList = [];
      }
    },
    async gioDetail() {
      const {
        productId, name, productCategoryName, sellPrice,
      } = this.courseDetail;
      const miniBeforePageName = window.localStorage.getItem('miniBeforePageName');
      const beforePage = miniBeforePageName || this.$route.query.beforePageName;
      const { data } = await reqClassNameType(productId);
      gio('track', 'courseDetailPage_event', {
        courseId_var: productId.toString(),
        courseName_var: name,
        courseCate_var: productCategoryName,
        courseSubject_var: this.lastStr(productCategoryName),
        coursePrice_var: sellPrice,
        isLogin_var: Boolean(this.userInfo.id).toString(),
        classSize_var: data.className,
        beforePageName_var: beforePageName(beforePage),
        platform_var: gioPlatform(this),
      });
    },
    // 截取最后一个斜杠后的内容
    lastStr(str) {
      // eslint-disable-next-line
      const index = str.lastIndexOf('/');
      // eslint-disable-next-line
      str = str.substring(index + 1, str.length);
      return str;
    },

    // 免费课购买
    async freeCourseReceive(index) {
      let referer = '';
      if (sessionStorage.getItem('fromPageUrl')) {
        const paramData = JSON.parse(sessionStorage.getItem('fromPageUrl'));
        referer = paramData.fromPageUrl ? paramData.fromPageUrl : paramData.fromPageUrlLast;
      }
      const subData = {
        // 订单提交请求对象
        channelMark: 5, // 下单渠道 ：5学员端下单
        products: [
          {
            productId: Number(this.courseId),
            quantity: 1, // 产品数量
            type: 1, // 产品类别 1-主产品 2-增值产品 3-赠送产品
          },
        ],
        terminalMark: this.$global.terminalMark,
        orderReferer: referer,
        // eslint-disable-next-line no-undef
        ip: sessionStorage.getItem('cityIp') || '',
        orderUrl: window.location.href,
        extendParam:  this.gioVisitUserId,
      };
      // alert(this.productSku.productSkuId);
      const checkGoOrderNow = JSON.parse(window.sessionStorage.getItem('checkGoOrderNow'));
      if (checkGoOrderNow && checkGoOrderNow.skuId) {
        subData.products[0].productSkuId = checkGoOrderNow.skuId;
      } else if (this.productSku.productSkuId) {
        subData.products[0].productSkuId = this.productSku.productSkuId;
      }
      // const { liveRoomId } = this.$route.query;
      // if (liveRoomId) subData.extendParam = JSON.stringify({ roomId: liveRoomId });
      window.sessionStorage.removeItem('checkGoOrderNow');
      this.$refs.load.show = true;
      const res = await reqSubOrder(subData); // （order/commit）
      if (res.code === 0) {
        const { orderNo } = res.data;
        const that = this;
        setTimeout(() => {
          if (index !== undefined) {
            // 【直播】免费领取并跳转直播
            // 更新页面
            that.getCourseDetail().then(() => {
              // 领取后打开直播
              setTimeout(() => {
                // 领取成功弹窗
                this.openDetailSuccessPopup(orderNo);
              }, 1000);
            });
          } else {
            // 免费领取 跳转领取成功
            // 更新页面
            that.getCourseDetail().then(() => {
              // 领取成功弹窗
              this.openDetailSuccessPopup(orderNo);
            });
          }
          this.$refs.load.show = false;
        }, 2000);
        this.gioFreecourse()
      } else {
        this.$refs.load.show = false;
        this.$toast(res.msg);
      }
    },
    // 关闭领取成功popup
    closeDetailSuccessPopup() {
      this.detailSuccessPopupShow = false;
      // 差禁止滑动
    },
    // 打开领取成功popup
    openDetailSuccessPopup(orderNo) {
      this.$sendToApp('hiddenShareButton', { showShare: 0 }, false);
      this.$router.push({
        path: '/paySuccess',
        query: { orderNo, type: 1 },
      });
    },
    miniParams() {
      const miniBeforePageName = window.localStorage.getItem('miniBeforePageName');
      const beforePage = miniBeforePageName || this.$route.query.beforePageName;

      return statusTextMap[beforePage] || '';
    },
    async gioDefault(query) {
      const res = await reqPrice({
        promotionBasicPrice: {
          endPoint: this.$root.$data.isApp ? 2 : 3,
          platform: 1,
        },
        promotionProductSkuPriceList: query,
      });
      if (res.code === 0) {
        const courseIdList = [];
        const courseNameList = [];
        const allianceId = [];
        const allianceName = [];
        const fullReductionId = [];
        const fullReductionName = [];
        const secondsKillNameList = [];
        const {
          orderPayPrice,
          orderTotalPrice,
          productCalculateResultRespList,
          fullDiscountPrice,
          unionDiscountPrice,
          unionCalculateResultRespList,
          promotionFullCalculateResultRespList,
          singleCalculateResultRespList,
        } = res.data;
        productCalculateResultRespList.forEach((element) => {
          courseIdList.push(element.productId);
          courseNameList.push(element.productName);
        });
        if (unionDiscountPrice) {
          unionCalculateResultRespList.forEach((element) => {
            allianceId.push(element.promotionId);
            allianceName.push(element.promotionName);
          });
        }
        if (fullDiscountPrice) {
          promotionFullCalculateResultRespList.forEach((element) => {
            fullReductionId.push(element.promotionId);
            fullReductionName.push(element.promotionName);
          });
        }
        if (singleCalculateResultRespList) {
          singleCalculateResultRespList.forEach((element) => {
            if (element.promotionLabel === 2 || element.promotionLabel === 3) {
              secondsKillNameList.push(element.promotionName);
            }
          });
        }
        // 立即购买埋点
        // eslint-disable-next-line
        gio('track', 'buyCourse_event', {
          courseIdList_var: courseIdList.toString(), // 课程 ID 列表
          courseNameList_var: courseNameList.toString(), // 课程名称列表
          courseTotalPrice_var: secondsKillNameList.length > 0 ? orderPayPrice : orderTotalPrice, // 课程总价
          isAlliance_var: unionDiscountPrice ? '是' : '否', // 是否参加联报
          allianceId_var: unionDiscountPrice ? allianceId.toString() : null, // 联报活动ID
          allianceName_var: unionDiscountPrice ? allianceName.toString() : null, // 联报活动名称
          allianceDiscountAmount_var: unionDiscountPrice || null, // 联报优惠金额
          isSecondsKill_var: secondsKillNameList.length > 0 ? '是' : '否', // 是否参加秒杀
          secondsKillNameList_var:
            secondsKillNameList.length > 0 ? secondsKillNameList.toString() : null, // 秒杀活动名称列表
          isFullReduction_var: fullDiscountPrice ? '是' : '否', // 是否参加满减
          fullReductionId_var: fullDiscountPrice ? fullReductionId.toString() : null, // 满减活动ID
          fullReductionName_var: fullDiscountPrice ? fullReductionName.toString() : null, // 满减活动名称
          fullReductionAmount_var: fullDiscountPrice || null, // 满减优惠金额
          platform_var: gioPlatform(),
        });
      }
    },

    // 加入购物车埋点
    gioAddCart() {
      const { productId, name, sellPrice } = this.courseDetail;
      // eslint-disable-next-line
      gio('track', 'addtoCart_event', {
        courseId_var: productId.toString(),
        courseName_var: name,
        coursePrice_var: sellPrice,
        platform_var: gioPlatform(),
      });
    },
    //小程序解锁免费课程埋点
   async gioFreecourse(){
      if(this.$root.miniprogram){
        const { productId, name, } = this.courseDetail;
        let res = await reqClassNameType(productId);
        let gioData = {
          enter_var: this.miniParams(),
          UnStyle_var: '购买课程',
          courseId_var: productId,
          courseName_var: name,
          classSize_var: res.data.className,
        }
        ConUnlocking_GIO(gioData);
        window.localStorage.removeItem('miniBeforePageName')
      }
    },
    //用于小程序端分享时区分是免费课还是付费课标识
   wxInit(buyBtnData) {
      let miniCourseFree = (buyBtnData?.state === 6?true:false)
      wx.ready(() => { // 需在用户可能点击分享按钮前就先调用
      wx.miniProgram.postMessage({
        data: {
          title: "课程详情",//这个是要传给微信小程序的标题
				  pathParams: `miniCourseFree=${miniCourseFree}`,//这个是要传给微信小程序的参数
          },
        });
      });
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.path !== '/registrationLogin') {
      // 离开时清除referer存储；除了去登录页
      sessionStorage.removeItem('fromPageUrl');
    }
    // 如果是从订单页返回的，则回退到主页
    if (to.name === 'indentDetail') {
      this.$router.push('/home');
    }
    next();
  },
  destroyed() {
    this.$store.dispatch('saveProductSku', {});
    this.$sendToApp('hiddenShareButton', { showShare: 0 }, false);
    // eslint-disable-next-line no-unused-expressions
    this.mutationObserverVal ? this.mutationObserverVal.disconnect() : '';
    // 清除public/index.hmtl中前端控制螳螂自动触发的定时器
    // clearTimeout(timesCustomer);
  },
};
</script>

<style lang="scss" scoped>
.course-detail-page {
  position: relative;
  width: 100%;
  height: calc(100vh - 120px);
  overflow-y: scroll;
}

::-webkit-scrollbar {
  // eslint-disable-next-line
  display: none;
}

.courseDetail {
  position: relative;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  background: #f6f6f6;

  .navVideoModule {
    width: 100%;
    height: 543px;
    background-color: #444;
  }

  .basicInformation {
    //基本信息模块
    width: 100%;
    padding: 36px 36px 0;
    background-color: #fff;
  }

  .coursePriceModule {
    width: 100%;
    overflow: hidden;
    background-color: #fff;
    border-radius: 0 0 14px 14px;
    box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.03);
  }

  .tab-out-empty {
    width: 100%;
    height: 22px;
  }

  .van-popup {
    overflow-y: visible;
  }

  .courseDetailLiveListBox {
    //直播中列表盒子
    position: relative;

    .liveListBoxIcon {
      position: absolute;
      top: -65px;
      left: 50%;
      z-index: 9999;
      width: 130px;
      transform: translate(-50%);
    }
  }
}
</style>
